<!--
 * @Description: 运营总览机构订单量Top10组件
 * @Author: gaohc
 * @Date: 2022-07-13 09:43:52
 * @LastEditTime: 2022-07-13 17:33:29
-->
<template>
  <div class="body">
    <div class="body-header">
      <span style="font-weight: 600; color: #333333;">机构订单量Top10</span>
    </div>
    <div class="inst-order-volume-topten">
      <div class="inst-order-volume-topten-item" v-for="(item,index) in institutionOrdersList" :key="index">
        <el-row type="flex" justify="space-between">
          <el-col :span="18" style="text-align: left">
            <span v-if="index + 1 == 1 ||  index + 1 == 2 || index + 1 == 3 " :style="setTextStyle(index)" class="ranking">
              {{index+1}}
            </span>
            <span class="instName">{{item.institutionName}}</span>
          </el-col>
          <el-col :span="6" style="text-align: right; color: #333333; font-size: 14px;">
            <span>{{item.orderCount}}</span>
          </el-col>
        </el-row>
        <el-row style="padding: 0; text-align: left; margin-top: 2px;" >
          <el-progress :percentage="item.orderCount" :show-text="false" :color="index == 0 ? '#3AC9EA' : '#3E7EF5'">
          </el-progress>
        </el-row>
      </div>
    </div> 
  </div>
</template>
<script>
export default {
  name: 'InstOrderVolume',
  props: ["institutionOrdersList"],
  data() {
    return {
    }
  },

  computed: {
  	//动态设置样式
  	setTextStyle() {
  	 return function (index) {
        if (index + 1 == 1) {
          return "opacity : 1";
        } else if (index + 1 == 2) {
          return "opacity : 0.8";
        } else if (index + 1 == 3) {
          return "opacity : 0.6";
        } else {
          return "color: #333; background: transparent;";
        }
      }
  	}
  },
  methods: {
  
  }
}
</script>
<style  scoped>
.body {
    height: 440px;
    border-radius: 6px;
    border: 1px solid #D7DDE5;
}

.body-header {
  display: flex;
  justify-content: space-between;
  height: 46px;
  line-height: 46px;
  padding: 0 20px;
  border-bottom: 1px solid #D7DDE5;
}

.inst-order-volume-topten {
 height: 335px;
 padding: 28px 30px 30px 32px;
 overflow-y: auto;
}

.inst-order-volume-topten-item {
 margin-bottom:8px;
}

.ranking {
  display: inline-block;
  text-align: center;
  line-height: 15px;
  width: 15px;
  height: 15px;
  background: #FE7C4B;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  color: #F9F9F9;
  margin-right: 10px;
}

.instName {
  font-size: 12px;
  font-weight: 400;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/components/overview/components/InstOrderVolume.vue